<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="侧边栏组件" transform="translate(-1131.000000, -952.000000)">
        <g id="编组-4备份-3" transform="translate(834.000000, 824.000000)">
          <g id="申请试用备份-4" transform="translate(277.000000, 124.000000)">
            <g id="编组-21" transform="translate(20.000000, 4.000000)">
              <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24"></rect>
              <g id="weixin-2" transform="translate(1.889357, 3.850312)" :fill="color">
                <path
                  d="M13.6887171,4.93155539 C13.9213796,4.93155539 14.1508327,4.94857656 14.3780513,4.9732763 C13.7589889,2.12025477 10.6759674,0 7.15719412,0 C3.22292324,0 0,2.65375955 0,6.0232409 C0,7.96788746 1.07247726,9.56507363 2.8639807,10.803864 L2.1482589,12.934864 L4.64999265,11.6930307 C5.54574438,11.868116 6.26362947,12.0486689 7.15719412,12.0486689 C7.38167881,12.0486689 7.60395266,12.0377335 7.82515676,12.0201893 C7.68518366,11.547067 7.60395268,11.0509089 7.60395268,10.5365887 C7.60397645,7.44263176 10.2890207,4.93155539 13.6887171,4.93155539 Z M9.84114491,3.01108558 C10.3801174,3.01108558 10.7368728,3.36234956 10.7368728,3.89530758 C10.7368728,4.42605473 10.3801174,4.78171666 9.84114491,4.78171666 C9.30433574,4.78171666 8.7664568,4.42605473 8.7664568,3.89530758 C8.7664568,3.36234956 9.30435951,3.01108558 9.84114491,3.01108558 Z M4.83220969,4.78169287 C4.29540052,4.78169287 3.75421718,4.42603094 3.75421718,3.89528379 C3.75421718,3.36232577 4.29540052,3.01106179 4.83220969,3.01106179 C5.36842455,3.01106179 5.72575055,3.36232577 5.72575055,3.89528379 C5.72575055,4.42605473 5.36842455,4.78169287 4.83220969,4.78169287 Z M20.221286,10.4515065 C20.221286,7.61990406 17.3578521,5.31191705 14.1420606,5.31191705 C10.7368728,5.31191705 8.05513295,7.61990409 8.05513295,10.4515065 C8.05513295,13.2872215 10.7368729,15.5902639 14.1420606,15.5902639 C14.854478,15.5902639 15.5735042,15.4134908 16.2891785,15.2356955 L18.2525341,16.2993769 L17.7140608,14.5298393 C19.1510434,13.4628535 20.221286,12.0486689 20.221286,10.4515065 Z M12.1683164,9.56507363 C11.8121315,9.56507363 11.4526184,9.21435641 11.4526184,8.85648362 C11.4526184,8.5035793 11.8121315,8.14846414 12.1683164,8.14846414 C12.7094998,8.14846414 13.0640681,8.5035793 13.0640681,8.85648362 C13.0640681,9.21435641 12.7094998,9.56507363 12.1683164,9.56507363 Z M16.1047744,9.56507363 C15.7513471,9.56507363 15.3940211,9.21435641 15.3940211,8.85648362 C15.3940211,8.5035793 15.7513471,8.14846414 16.1047744,8.14846414 C16.6415835,8.14846414 17.0005261,8.5035793 17.0005261,8.85648362 C17.0005261,9.21435641 16.6415835,9.56507363 16.1047744,9.56507363 Z"
                  id="形状"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
  components: {},
  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="less" scoped></style>
